module.exports = __webpack_public_path__ + "static/media/nichiyoumobizhishu@2x.ffbbb862.png";